import React, { useEffect } from 'react';
import { getManifestUrl, validateManifestExists } from '../utils/manifestUtils';

/**
 * Component that handles dynamic manifest.json loading
 * Replaces the static %PUBLIC_URL% placeholder with proper runtime values
 */
export const ManifestHandler: React.FC = () => {
  useEffect(() => {
    let manifestLink: HTMLLinkElement | null = null;

    const setupManifest = async () => {
      try {
        // Remove existing manifest link if it exists
        const existingLink = document.querySelector('link[rel="manifest"]');
        if (existingLink) {
          existingLink.remove();
        }

        // Get the correct manifest URL
        const manifestUrl = getManifestUrl();

        // Create new manifest link
        manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        manifestLink.href = manifestUrl;
        document.head.appendChild(manifestLink);

        // Validate the manifest exists (non-blocking)
        try {
          await validateManifestExists(manifestUrl);
        } catch (error) {
          console.warn('Failed to validate manifest:', error);
          // Don't remove the link - let the browser handle the 404
        }
      } catch (error) {
        console.error('Failed to setup manifest:', error);
      }
    };

    setupManifest();

    // Cleanup function
    return () => {
      if (manifestLink && document.head.contains(manifestLink)) {
        document.head.removeChild(manifestLink);
      }
    };
  }, []); // Empty dependency array - run once on mount

  return null; // This component doesn't render anything visible
};